import React, { useContext, useEffect, useState } from 'react'
import { LuMapPin } from "react-icons/lu";
import { BsThreeDotsVertical } from "react-icons/bs";
import EditCalender from './EditCalender';
import EditNotes from './EditNotes';
import DeleteItem from './DeleteItem';
import Reschedule from './Reschedule';
import { LeadsContext } from '../Context/LeadsContext';

export default function WeekCalender({ activeLocations, leadData, setappraisalData, csLocation }) {
   
   const {updateLeadDataMultiple,addNote,updateLeadData} = useContext(LeadsContext);

   useEffect(() => {
      setPrevSlots(leadData);
   }, [leadData]);
   
   const [prevSlots, setPrevSlots] = useState(leadData);
   const [currentSlots, setCurrentSlots] = useState([]);


   useEffect(() => {
      const transformAppraisalData = (timeSlots) => {
         //console.log(timeSlots);
         const groupedByDate = timeSlots.reduce((acc, timeSlot) => {
            const dateString = timeSlot.appointment_date.split('T')[0]; // Get the date in 'YYYY-MM-DD' format
            if (!acc[dateString]) {
               acc[dateString] = {
                  date: dateString,
                  slots: [],
               };
            }
            const timeString = timeSlot.appointment_date_obj.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            const time24String = timeSlot.appointment_date_obj.toLocaleTimeString('en-US', { hourCycle: 'h23', hour: '2-digit', minute: '2-digit' });

            // Create the slot object
            const slot = {
               id: timeSlot.id,
               time: timeString,
               time24: time24String,
               location: timeSlot.location,
               name: timeSlot.full_name,
               vehicle: timeSlot.vehicle_name,
               phone: timeSlot.phone,
               notes: timeSlot.notes,
               appointment_date: dateString.split(' ')[0],
               lead_type: timeSlot.lead_type,
               appraisal_stage: timeSlot.appraisal_stage
            };

            // Push the slot to the correct date
            acc[dateString].slots.push(slot);

            return acc;
         }, {});

         //console.log(timeSlots,groupedByDate);

         // Convert the grouped object into an array
         return Object.values(groupedByDate).sort((a,b) => a.date > b.date ? 1 : -1);
      };
      const transformedData = prevSlots ? transformAppraisalData(prevSlots) : [];

      //console.log(transformedData);

      //console.log(transformedData);
      setCurrentSlots(transformedData);
   }, [prevSlots]);

   const CUSTOMDROPDOWN = ({ children, text }) => {
      const [open, setOpen] = useState(false);
      return <div className="btn-group calender-dropdown custom-dropdown ms-3 position-relative">
         <button onClick={() => setOpen(!open)} className="btn btn-secondary dropdown-toggle text-green" >
            {text}
         </button>
         <div className={`dropdown-menu dropdown-menu-custom dropdown-menu-end right-0 ${open ? "show" : ''}`}>
            {children}
         </div>
      </div>
   }

   const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
   ];

   const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
   ];

   const tzoffset = (new Date()).getTimezoneOffset() * 60000;

   const dayOfWeek = (date) => {
      const string = new Date(Date.parse(date) + tzoffset);
      const dayOfWeek = daysOfWeek[string.getDay()];
      return dayOfWeek;
   }
   const monthOfYear = (date) => {
      const string = new Date(Date.parse(date) + tzoffset);
      const month = months[string.getMonth()];
      return month;
   }
   const dayOfMonth = (date) => {
      const string = new Date(Date.parse(date) + tzoffset);
      const dayOfMonth = string.getDate();
      return dayOfMonth;
   }

   // useEffect(()=>{
   //    const today = new Date();
   //    const todayDayOfWeek = today.getDay();
   //    const weekStart = new Date(today);
   //    weekStart.setDate(today.getDate() - todayDayOfWeek);
   //    const weekDays = [];
   //    for (let i = 0; i < 7; i++) {
   //       const date = new Date(weekStart);
   //       date.setDate(weekStart.getDate() + i);
   //       weekDays.push(date);
   //    }
   //    const currentWeekDays = weekDays;
   //    const arr = [];
   //    currentWeekDays.forEach(date => {
   //       const string = new Date(date);
   //       const dayOfWeek = daysOfWeek[string.getDay()];
   //       const month = months[string.getMonth()];
   //       const dayOfMonth = string.getDate();
   //       arr.push({
   //          date: date.toDateString(),
   //          dayOfMonth: dayOfMonth,
   //          dayOfWeek: dayOfWeek,
   //          month: month,
   //          slots : null
   //       })
   //       console.log(); 
   //    });
   //    setCurrentWeek(arr);
   // },[]);

   return (
      <div className='calender-week'>
         {currentSlots && currentSlots.map((item, index) => (
            <div className='daybox' key={index}>
               <div className="classbar">
                  <div className='left-d'>
                     <div className='month text-uppercase'>{monthOfYear(item.date)}</div>
                     <div className='day'>{dayOfMonth(item.date)}</div>
                  </div>
                  <div className='right-d'>
                     <div className='dayofweek'>{dayOfWeek(item.date)}</div>
                  </div>
               </div>

               <div className='timeslot'>
                  <div className='slot'></div>
                  <div className='dynmic-right'>
                     <div className='slot-item py-3 thead'>
                        <div className='tableslots w-full'>
                           <p className='s-c1'>Location</p>
                           <p className='s-c2'>Name</p>
                           <p className='s-c3'>Vehicle</p>
                           <p className='s-c4'>Phone</p>
                           <p className='s-c5'>Notes</p>
                           <p className='s-c6'></p>
                        </div>
                     </div>
                  </div>
               </div>
               {item.slots && item.slots.length && item.slots.map((s, j) => {
                  return <div className={`load ${activeLocations && activeLocations.includes(s.location) ? 'd-flex' : 'd-none'} timeslot mb-2`} key={j}>
                     <div className='slot text-white pt-3 ps-2'>{s.time}</div>
                     <div className='dynmic-right'>
                        <div
                           className={`slot-item ${s.appraisal_stage != "InQueue" ? "bg-yellow" : (s.location === "BOYNTON BEACH" ? 'bg-blue' : 'bg-green')} p-3 ps-2 rounded-14`}
                        >
                           <div className='tableslots text-white'>
                              <div className='s-c1'>
                                 <div className='d-flex align-center '>
                                    <LuMapPin size={'1.6rem'} className='mapicon me-1' /><p>{csLocation || s.location}</p>
                                 </div>
                              </div>
                              <p className='s-c2'>{s.name}</p>
                              <p className='s-c3'>{s.vehicle}</p>
                              <p className='s-c4'>{s.phone}</p>
                              <p className='s-c5'>{s.notes.find((note) => note.title == "Appointment Details")?.note}</p>
                              <div className='s-c6'>
                                 <CUSTOMDROPDOWN text={<BsThreeDotsVertical />} >
                                    <EditCalender updateLeadDataMultiple={updateLeadDataMultiple} leadData={s} button={<><button className="dropdown-item text-dblue font-bold text-uppercase" type="button">Edit</button></>} />
                                    <Reschedule updateLeadData={updateLeadData} leadData={s} button={<><button className="dropdown-item text-dblue font-bold text-uppercase" type="button">Reschedule</button></>} />                                    
                                    <button className="dropdown-item text-dblue font-bold text-uppercase" type="button" onClick={() => {window.open(`/web?lead_id=${s.id}`, "_blank");}}>Go To Lead</button>
                                    <EditNotes addNote={addNote} leadData={s} button={<><button className="dropdown-item text-dblue font-bold text-uppercase" type="button">Notes</button></>} />
                                    <DeleteItem updateLeadDataMultiple={updateLeadDataMultiple} leadData={s} button={<><button className="dropdown-item text-dblue font-bold text-uppercase" type="button">Notes</button></>} />
                                 </CUSTOMDROPDOWN>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               })}
            </div>
         ))
         }</div>
   )
}
